export default "<h1>Мои программы обучения</h1>\r\n<ul>\r\n  <li><a href='settings'>Настройки</a></li>\r\n</ul>\r\n";